import React, { useEffect, useState } from "react";
import {Table, Row, Col, Card, CardBody, Modal, CardTitle, ModalHeader, ModalBody, FormGroup, Label, InputGroup, Button} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import * as url from "../../helpers/url_helper"
import moment from "moment";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { PhoneInput } from 'react-international-phone';
import { json, Link } from "react-router-dom";
const Tarifications = () => {
  document.title = "AMAVIE | Gestion de la tarification";
  
  const [tarifications, setTarifications]= useState([])
  const [tranches, setTranches]= useState([{label: "Toutes les tranche", value: 0}])
  const [zones, setZones]= useState([{label: "Toutes les zones", value: 0}])
  const [periodicities, setPeriodicities]= useState([{label: "Toutes les périodes", value: 0}])
  const [tranche, setTranche]= useState(null)
  const [zone, setZone]= useState(null)
  const [periodicity, setPeriodicity]= useState(null)
  
  const removeBodyCss = () => { document.body.classList.add("no_padding"); };

  const loadZones=()=> {
      fetch(`${url.BACKEND_URL}/zones`, { method: 'GET', headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => { 
        console.log(responseJson.data)
        if (responseJson.status==200) {
          setZones([...zones, ...responseJson.data.map(item=>({label: item.name, value: item.id}))])
      } else { setZones([]); }
      }) .catch((error) => { });
    };

  const loadTranches=()=> {
        fetch(`${url.BACKEND_URL}/tranches`, { method: 'GET', headers: { Accept: 'application/json'} })
        .then((response) => response.json())
        .then((responseJson) => {           
          if (responseJson.status==200) {
            setTranches([...tranches, ...responseJson.data.map(item=>({label: `${item.min} à ${item.max} ans`, value: item.id}))])
        } else { setTranches([]); }
        }) .catch((error) => { });
      };

  const loadPeriodicities=()=> {
        fetch(`${url.BACKEND_URL}/periodicities`, { method: 'GET', headers: { Accept: 'application/json'} })
        .then((response) => response.json())
        .then((responseJson) => {           
          if (responseJson.status==200) {
            setPeriodicities([...periodicities, ...responseJson.data.map(item=>({label: `${item.min} à ${item.max} jours`, value: item.id}))])
        } else { setPeriodicities([]); }
        }) .catch((error) => { });
      };

  const loadTarification=(tranche, zone, periodicity)=> {
      fetch(`${url.BACKEND_URL}/tarifications?tranche=${tranche ? tranche.value: 0}&zone=${zone ? zone.value: 0}&periodicity=${periodicity ? periodicity.value: 0}`, {
        method: 'GET', headers: { Accept: 'application/json'} })
      .then((response) => response.json())
      .then((responseJson) => { 
        if (responseJson.status==200) { setTarifications(responseJson.data) }
        else { setTarifications([]) }
      }) .catch((error) => {  });
    };

  useEffect(()=>{ loadTarification(tranche, zone, periodicity), loadZones(), loadTranches(), loadPeriodicities() }, [])
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="AMAVIE" title="Tarifications" />
          <Row>
            <CardTitle className="h4">Liste des tarifications</CardTitle>
            <Col md={3}>
              <div className="mb-3">
                <Label>Zone</Label>
                <Select
                  value={zone}
                  onChange={(event)=>{setZone(event)}}
                  options={zones}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
            <Col md={3}>
              <div className="mb-3">
                <Label>Tranche</Label>
                <Select
                  value={tranche}
                  onChange={(event)=>{setTranche(event)}}
                  options={tranches}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
            <Col md={3}>
              <div className="mb-3">
                <Label>Période</Label>
                <Select
                  value={periodicity}
                  onChange={(event)=>{setPeriodicity(event)}}
                  options={periodicities}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
            <Col md={3}>
              <div className="mb-3">
                <Label style={{ visibility: "hidden" }}>--</Label>
                <Button color="primary" className="form-control btn btn-primary waves-effect waves-light" onClick={()=>loadTarification(tranche, zone, periodicity)}><i className="fas fa-search"></i> Rechercher</Button>
              </div>
            </Col>
             <Col xl={3}>
                <Label style={{ visibility: "hidden" }}>--</Label>
                <Link color="primary" onClick={()=>alert("OK")} className="form-control btn btn-warning waves-effect"><i className="fas fa-money-check-alt"></i> Ajouter une Tarification</Link>
              </Col>
          </Row>
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <div className="table-responsive">
                    <Table className="table mb-0" style={{fontSize: 16}}>
                      <thead className="table-light">
                        <tr>
                          <th>Zone</th>
                          <th>Période</th>
                          <th>Tranche d'age</th>
                          <th>Montant</th>
                          <th>Modifier</th>
                          {/* <th>Détails</th> */}
                        </tr>
                      </thead>
                      <tbody>
                         {tarifications.map((item, key)=>(
                            <tr>
                              <td><span className="badge bg-success" style={{padding: 7}}>{item?.zone.name}</span></td>
                              <td>
                                <span className="badge bg-warning" style={{padding: 7}}>
                                  De {item?.periodicity?.min} {" "} à {item?.periodicity?.max} jours
                                </span>
                              </td>
                              <td>
                                <span className="badge bg-info" style={{padding: 7}}>
                                  De {item?.tranche?.min} {" "} à {item?.tranche?.max} an(s)
                                </span>
                              </td>
                              <td><span className="badge bg-primary" style={{padding: 7}}>{(item?.tarif).toLocaleString("fr-FR")} FCFA</span></td>
                              <td>Modifier</td>
                              {/* <td><a className="fas fa-book" onClick={()=>{setTimeout(() => { tog_detail_tarification(item)}, 400);}}></a></td> */}
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Tarifications;
